<template>
  <div>
    <div
      class="alert alert-warning alert-has-icon"
      v-if="isWajib === 0"
    >
      <div class="alert-icon">
        <i class="far fa-lightbulb" />
      </div>
      <div class="alert-body">
        <div class="alert-title">
          Form Ini Hanya Diisi Jika Diperlukan
        </div>
        Form ini tidak wajib diisi. Hanya diisi jika diperlukan
      </div>
    </div>
    <form
      action=""
      method="POST"
      @submit="onSubmit"
    >
      <div class="form-group row">
        <label
          for=""
          class="col-form-label col-md-4 text-md-right text-left"
        >
          NIK
          <span
            v-if="isWajib === 1"
            class="text-danger"
          >
            *
          </span>
        </label>
        <div class="col-md-6">
          <input
            type="text"
            class="form-control"
            required
            v-model="form.nik"
            maxlength="16"
            :disabled="disabledForm"
          >
        </div>
      </div>
      <div class="form-group row">
        <label
          for=""
          class="col-form-label col-md-4 text-md-right text-left"
        >
          Nama
          <span
            v-if="isWajib === 1"
            class="text-danger"
          >
            *
          </span>
        </label>
        <div class="col-md-6">
          <input
            type="text"
            class="form-control"
            required
            v-model="form.nama"
            maxlength="255"
            :disabled="disabledForm"
          >
        </div>
      </div>
      <h4 class="section-title">
        Keterangan Sebagai Non Permanen
      </h4>
      <hr>
      <div class="form-group row">
        <label
          for=""
          class="col-form-label col-md-4 text-md-right text-left"
        >
          Alamat
          <span
            v-if="isWajib === 1"
            class="text-danger"
          >
            *
          </span>
        </label>
        <div class="col-md-6">
          <textarea
            class="form-control"
            v-model="form.alamat"
            :disabled="disabledForm"
          />
        </div>
      </div>
      <div class="form-group row">
        <label
          for=""
          class="col-form-label col-md-4 text-md-right text-left"
        >
          RT/RW
          <span
            v-if="isWajib === 1"
            class="text-danger"
          >
            *
          </span>
        </label>
        <div class="col-md-6">
          <input
            type="text"
            class="form-control"
            required
            v-model="form.rt_rw"
            maxlength="255"
            :disabled="disabledForm"
          >
        </div>
      </div>

      <!-- provinsi -->
      <div class="form-group row">
        <label
          for=""
          class="col-form-label col-md-4 text-md-right text-left"
        >
          Provinsi
          <span
            v-if="isWajib === 1"
            class="text-danger"
          >
            *
          </span>
        </label>
        <div class="col-md-6">
          <v-select
            :options="['Bali']"
            v-model="formWilayah.provinsi"
            :disabled="disabledForm"
          />
        </div>
      </div>

      <!-- kabkot -->
      <div class="form-group row">
        <label
          for=""
          class="col-form-label col-md-4 text-md-right text-left"
        >
          Kabupaten/Kota
          <span
            v-if="isWajib === 1"
            class="text-danger"
          >
            *
          </span>
        </label>
        <div class="col-md-6">
          <v-select
            :options="['Jembrana']"
            v-model="formWilayah.kabupaten"
            :disabled="disabledForm"
          />
        </div>
      </div>

      <!-- kecamatan -->
      <div class="form-group row">
        <label
          for=""
          class="col-form-label col-md-4 text-md-right text-left"
        >
          Kecamatan
          <span
            v-if="isWajib === 1"
            class="text-danger"
          >
            *
          </span>
        </label>
        <div class="col-md-6">
          <v-select
            :options="dataKec"
            v-model="formWilayah.kecamatan"
            label="nama_kecamatan"
            :loading="loadingKec"
            :disabled="disabledForm"
          />
        </div>
      </div>

      <!-- desa -->
      <div class="form-group row">
        <label
          for=""
          class="col-form-label col-md-4 text-md-right text-left"
        >
          Desa/Kelurahan
          <span
            v-if="isWajib === 1"
            class="text-danger"
          >
            *
          </span>
        </label>
        <div class="col-md-6">
          <v-select
            :options="dataDesa"
            v-model="form.id_desa"
            label="nama_desa"
            :loading="loadingDesa"
            :disabled="disabledForm"
          />
        </div>
      </div>

      <h4 class="section-title">
        Keperluan Sebagai Non Permanen
      </h4>
      <hr>
      <div
        v-for="d in ['Pekerjaan', 'Pendidikan', 'Lainnya']"
        :key="d"
        class="form-group row"
      >
        <label
          for=""
          class="col-form-label col-md-4 text-md-right text-left"
        >
          {{ d }}
        </label>
        <div class="col-md-6">
          <textarea
            class="form-control"
            v-model="form[`keperluan_${d.toLowerCase()}`]"
            :disabled="disabledForm"
          />
        </div>
      </div>

      <h4 class="section-title">
        Jangka Waktu Sebagai Non Permanen
      </h4>
      <hr>
      <div class="form-group row">
        <label
          for=""
          class="col-form-label col-md-4 text-md-right text-left"
        >
          Jangka Waktu
          <span
            v-if="isWajib === 1"
            class="text-danger"
          >
            *
          </span>
        </label>
        <div class="col-md-6">
          <input
            type="text"
            class="form-control"
            required
            v-model="form.jangka_waktu"
            maxlength="255"
            :disabled="disabledForm"
          >
        </div>
      </div>

      <h4 class="section-title">
        Pembatalan Penduduk Non Permanen Alasan
      </h4>
      <hr>
      <div
        v-for="d in ['Pekerjaan', 'Pendidikan', 'Lainnya']"
        :key="d"
        class="form-group row"
      >
        <label
          for=""
          class="col-form-label col-md-4 text-md-right text-left"
        >
          {{ d }}
        </label>
        <div class="col-md-6">
          <textarea
            class="form-control"
            v-model="form[`pembatalan_${d.toLowerCase()}`]"
            :disabled="disabledForm"
          />
        </div>
      </div>

      <!-- tombol simpan -->
      <div
        v-if="showBtnSimpan"
        class="form-group row"
      >
        <label
          for=""
          class="col-form-label col-md-4 text-md-right text-left"
        />
        <div class="col-md-6">
          <b-button
            id="btnSubmitPendudukNonPermanen"
            class="mx-1"
            type="submit"
            variant="primary"
          >
            Simpan
          </b-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import swal from 'sweetalert'

export default {
  data() {
    return {
      form: {
        nik: '',
        nama: '',
        alamat: '',
        rt_rw: '',
        id_desa: '',
        keperluan_pekerjaan: '',
        keperluan_pendidikan: '',
        keperluan_lainnya: '',
        jangka_waktu: '',
        pembatalan_pekerjaan: '',
        pembatalan_pendidikan: '',
        pembatalan_lainnya: ''
      },
      dataKec: [],
      loadingKec: false,
      dataDesa: [],
      loadingDesa: false,
      formWilayah: {
        provinsi: 'Bali',
        kabupaten: 'Jembrana',
        kecamatan: {}
      }
    }
  },
  computed: {
    dataPermohonan() {
      return this.$store.getters.getDataPermohonan
    },
    profile() {
      return this.$store.getters.getUserProfile
    },
    showBtnSimpan() {
      return !this.disabledForm
    }
  },
  props: {
    data: {
      type: Object,
      default: () => null
    },
    disabledForm: {
      type: Boolean,
      default: () => null
    },
    isWajib: {
      type: Number,
      default: () => null
    }
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()

      // validasi disini

      if (this.form.id_desa === '') {
        swal({
          title: "Kesalahan",
          text: "Lengkapi form",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }

      let button = document.querySelector('#btnSubmitPendudukNonPermanen')
      let buttonHtml = button.innerHTML

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Simpan'


      let idDataPermohonan = this.$store.getters.getDataPermohonan.id_data_permohonan

      let formData = new FormData()
      for (let key in this.form) {
        if(key !== 'id_desa'){
          let val = (!this.form[key]) ? '' : this.form[key]
          formData.append(key, val)
        }
      }
      formData.append('id_desa', this.form.id_desa.id_desa)
      formData.append('id_data_permohonan', idDataPermohonan)


      this.$store.dispatch('storeFormPendudukNonPermanen', formData).then(res => {
        if (res.data.status) {
          swal({
            title: "Berhasil",
            text: res.data.message,
            icon: "success",
            buttons: "Ok"
          })
          this.$emit('handleSuccess')
        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml
      }).catch(err => {
        switch (err.response.status) {
          case 500:
            this.$router.push({ path: '/500' })
            break;

          case 400:
            swal({
              title: "Gagal",
              text: (typeof (err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;

          default:
            swal({
              title: "Gagal",
              text: err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;
        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml
      })


    },
    loadKecamatan() {
      this.loadingKecamatan = true
      const optKec = [
        {
          id_kecamatan: '0',
          nama_kecamatan: 'Pilih Kecamatan'
        }
      ]
      this.$store.dispatch('fetchKecamatan', { id_kabupaten: 274 }).then(res => {
        if (res.data.status) {
          res.data.data.forEach(e => {
            optKec.push({
              id_kecamatan: e.id_kecamatan,
              nama_kecamatan: e.nama_kecamatan
            })
          })
          this.dataKec = optKec

          if (this.data) {
            // set dari jawaban yang sudah disimpan
            this.formWilayah.kecamatan = this.dataKec.find(e => e.id_kecamatan === this.data.desa.id_kecamatan)
          } else {
            // jika belum ada data yang disimpan, set dari profil
            this.formWilayah.kecamatan = this.dataKec.find(e => e.id_kecamatan === this.profile.desa.id_kecamatan)
          }
          this.loadingKec = false
        } else {
          swal({
            title: 'Gagal',
            text: res.data.message,
            icon: 'error',
            buttons: 'Ok'
          })
        }
      })
    },
    loadDesa() {
      if (this.formWilayah.kecamatan.id_kecamatan === '0') {
        return false
      }
      this.loadingDesa = true
      const optDes = [
        {
          id_desa: '0',
          nama_desa: 'Pilih Desa/Kelurahan'
        }
      ]
      this.$store.dispatch('fetchDesa', { id_kecamatan: this.formWilayah.kecamatan.id_kecamatan }).then(res => {
        if (res.data.status) {
          res.data.data.forEach(e => {
            optDes.push(e)
          })
          this.dataDesa = optDes
          this.loadingDesa = false

          if (this.data) {
            // set dari jawaban yang sudah disimpan
            this.form.id_desa = this.dataDesa.find(e => e.id_desa === this.data.id_desa)
          } else {
            // jika belum ada data yang disimpan, set dari profil
            this.form.id_desa = this.dataDesa.find(e => e.id_desa === this.profile.id_desa)
          }
        } else {
          swal({
            title: 'Gagal',
            text: res.data.message,
            icon: 'error',
            buttons: 'Ok'
          })
        }
      })
    },
    setForm(data) {
      for (let key in this.form) {
        if (data[key] && key !== 'id_desa') {
          this.form[key] = data[key]
        }
      }
      
      // this.formWilayah.kecamatan = this.dataKec.find(e => e.id_kecamatan === data.desa.id_kecamatan)
      // this.form.id_desa = this.dataDesa.find(e => e.id_desa === data.id_desa)
    },
    setFormByProfil(data) {
      this.form.nama = data.nama_lengkap
      this.form.nik = data.nik
      
      // this.formWilayah.kecamatan = this.dataKec.find(e => e.id_kecamatan === data.desa.id_kecamatan)
      // this.form.id_desa = this.dataDesa.find(e => e.id_desa === data.id_desa)
      this.form.alamat = data.alamat
    }
  },
  mounted () {
    this.loadKecamatan()
  },
  created() {
    if (this.data) {
      this.setForm(this.data)
    } else {
      if (this.profile) {
        this.setFormByProfil(this.profile)
      }
    }
  },
  watch: {
    dataPermohonan(newVal) {
      let data = newVal.form.find(e => e.id === 115).form_data
      if (data) {
        this.setForm(data)
      }
    },
    profile(newVal) {
      this.setFormByProfil(newVal)
    },
    'formWilayah.kecamatan'(newVal) {
      this.loadDesa()
    }
  }
}
</script>